class LoadMoreButton extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  #button = null;

  /** @type {HTMLElement | null} */
  #message = null;

  /** @type {HTMLElement | null} */
  #productGrid = null;

  /** @type {boolean} */
  #isLoading = false;

  connectedCallback() {
    this.#button = this.querySelector('.load-more-btn');
    this.#message = this.querySelector('.load-more-message');
    this.#productGrid = document.querySelector('[data-testid="product-grid"]');

    if (!this.#productGrid) {
      this.hidden = true;
      return;
    }

    this.#button?.addEventListener('click', () => this.#loadMore());
  }

  async #loadMore() {
    if (this.#isLoading) return;

    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl || !this.#button || !this.#message) return;

    this.#isLoading = true;
    this.#button.disabled = true;
    this.#button.textContent = 'Loading...';
    this.#message.textContent = '';

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[data-testid="product-grid"]');
      if (!newGrid || newGrid.children.length === 0) {
        throw new Error('No products found in response');
      }

      for (const item of Array.from(newGrid.children)) {
        this.#productGrid?.appendChild(item);
      }

      /** @type {LoadMoreButton | null} */
      const nextLoadMore = doc.querySelector('load-more-button');
      if (nextLoadMore && nextLoadMore.dataset.nextUrl) {
        this.dataset.nextUrl = nextLoadMore.dataset.nextUrl;
        this.#button.textContent = 'Load More';
        this.#button.disabled = false;
      } else {
        this.hidden = true;
      }
    } catch (error) {
      console.error('Load More error:', error);
      this.#message.textContent = 'Failed to load products. Please try again.';
      this.#button.textContent = 'Load More';
      this.#button.disabled = false;
    } finally {
      this.#isLoading = false;
    }
  }
}

if (!customElements.get('load-more-button')) {
  customElements.define('load-more-button', LoadMoreButton);
}
